import { fragmentShader, vertexShader } from "./shaders.js";

export default class InitProgram {
  constructor(context) {
    this._context = context;
    this.program = this.createProgram();
    this.enableAttribs = ["a_position"];
    this.enableUniforms = ["u_color", "u_shift", "u_rollIndex", "u_scale", "u_windowSize"];
    this.attribs = this.getEnableAttribs();
    this.uniforms = this.getEnableUnifroms();
    this._context.useProgram(this.program);
  }

  createProgram() {
    const loadLineFrShader = this.loadShader(this._context, fragmentShader, this._context.FRAGMENT_SHADER);
    const loadLineVertShader = this.loadShader(this._context, vertexShader, this._context.VERTEX_SHADER);
    return this.createProgramInfo(this._context, [loadLineVertShader, loadLineFrShader]);
  }

  createProgramInfo(gl, shaderSources) {
    const program = gl.createProgram();
    shaderSources.forEach(function (shader) {
      gl.attachShader(program, shader);
    });

    gl.linkProgram(program);

    // Check the link status
    const linked = gl.getProgramParameter(program, gl.LINK_STATUS);
    if (!linked) {
      // something went wrong with the link
      const lastError = gl.getProgramInfoLog(program);
      console.error("Error in program linking:" + lastError); // eslint-disable-line no-console

      gl.deleteProgram(program);
      return null;
    }
    return program;
  }

  loadShader(gl, shaderSource, shaderType) {
    // Create the shader object
    const shader = gl.createShader(shaderType);

    // Load the shader source
    gl.shaderSource(shader, shaderSource);

    // Compile the shader
    gl.compileShader(shader);

    // Check the compile status
    const compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    if (!compiled) {
      // Something went wrong during compilation; get the error
      const lastError = gl.getShaderInfoLog(shader);
      console.log("*** Error compiling shader '" + shader + "':" + lastError); // eslint-disable-line no-console
      gl.deleteShader(shader);
      return null;
    }

    return shader;
  }

  getEnableAttribs() {
    const attribs = {};
    this.enableAttribs.forEach(item => {
      attribs[item] = this._context.getAttribLocation(this.program, item);
    });

    this._context.enableVertexAttribArray(attribs.a_position);

    const positionBuffer = this._context.createBuffer();
    this._context.bindBuffer(this._context.ARRAY_BUFFER, positionBuffer);  
    this._context.vertexAttribPointer(attribs.a_position, 2, this._context.FLOAT, false, 0, 0);

    return attribs;
  }

  getEnableUnifroms() {
    const uniforms = {};
    this.enableUniforms.forEach(item => {
      uniforms[item] = this._context.getUniformLocation(this.program, item);
    });

    return uniforms;
  }

  setUnforms(uniforms) {
    for (let prop in uniforms) {
      if (prop === "u_rollIndex") {
        this._context.uniform1f(this.uniforms[prop], uniforms[prop]);
      } else if (prop === "u_color") {
        this._context.uniform4fv(this.uniforms[prop], uniforms[prop]);
      } else {
        this._context.uniform2f(this.uniforms[prop], uniforms[prop][0], uniforms[prop][1]);
      }
    }
  }
}
